import { createStore,applyMiddleware } from 'redux';
import rootReducer from './reducers';
import { thunk } from 'redux-thunk';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage,
    debug: true, // toggle this flag to true to start logging detailed messages
  };
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const configureStore = () => {
  return createStore(
    persistedReducer,
    applyMiddleware(thunk)
    // apply any middleware like redux-thunk or redux-saga if you are using
  );
};
// export const configureStore = () => createStore(rootReducer,applyMiddleware(thunk));
